module.exports = __webpack_public_path__ + "img/icon17.e9f62501.svg";